import { Injectable } from '@angular/core';
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

import { appEnv } from '../../../app.config';
@Injectable({
  providedIn: 'root'
})
export class WebsocketService {
  private _echo?: Echo<any>;
  public wsAuthChannel: any;
  public socketId: string = '';

  constructor() {}

  initWebsocket () {
    this._echo = new Echo({
      broadcaster: 'pusher',
      cluster: appEnv.pusher.cluster,
      key: appEnv.pusher.key,
      wsHost: appEnv.pusher.hostName,
      wsPort: appEnv.pusher.port,
      forceTLS: !appEnv.dev,
      enabledTransport: appEnv.dev ? ['ws'] : ['wss'],
      authEndpoint: appEnv.pusher.authUrl,
      auth: {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('custm_token'),
          Accept: 'application/json'
        }
      },
    });

    this.wsAuthChannel = this._echo.private('ws-auth-user');

    this.wsAuthChannel.subscribed(() => {
      /* Only get socketId once auth success */
      const socketSenderId = this._echo?.socketId();
      if (socketSenderId) {
        this.socketId = socketSenderId;
      }
    }).error(() => {
      console.log('authentication failed');
    });
  }

  public get echo(): Echo<any> {
    return this._echo as Echo<any>;
  }

  public leaveChannel () {
    this._echo?.leave('ws-auth-user');
  }

}
